import { render } from "./component-adress-region-name.vue?vue&type=template&id=45060d41"
import script from "./component-adress-region-name.vue?vue&type=script&setup=true&lang=js"
export * from "./component-adress-region-name.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/counteragents/counteragent-version-card/components/component-adress-region-name.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "45060d41"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('45060d41', __exports__)) {
    api.reload('45060d41', __exports__)
  }
  
  module.hot.accept("./component-adress-region-name.vue?vue&type=template&id=45060d41", () => {
    api.rerender('45060d41', render)
  })

}


export default __exports__